import { ComponentType } from '@angular/cdk/portal';
import {
  Injector,
  ViewContainerRef,
  ComponentFactoryResolver,
  TemplateRef
} from '@angular/core';
import { v1 as uuid } from 'uuid';

export interface DxWindowSettings {
  id?: string;
  title?: string;
  icon?: string;
  width?: string;
  height?: string;
  resizeable?: boolean;
  draggable?: boolean;
  panelClass?: string;
}

export interface WindowConfig<D, T> extends DxWindowSettings {
  component?: ComponentType<T>;
  template?: TemplateRef<T>;
  data?: D;
  injector?: Injector | null;
  viewContainerRef?: ViewContainerRef | null;
  componentFactoryResolver?: ComponentFactoryResolver | null;
}

export const DEFAULT_WINDOW_CONFIG: WindowConfig<any, any> = {
  id: uuid(),
  resizeable: true,
  draggable: true,
  viewContainerRef: null,
  injector: null,
  componentFactoryResolver: null,
};
